import * as React from 'react';

const SvgIcon = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill={props.fill || '#1D252D'} viewBox="0 -960 960 960">
      <path d="M633.85-293.85 591.08-336l184-184-184-184 42.77-42.15L860-520zM100-220v-140q0-78.77 55.62-134.38Q211.23-550 290-550h272.77l-154-154 42.77-42.15L677.69-520 451.54-293.85 408.77-336l154-154H290q-53.85 0-91.92 38.08Q160-413.85 160-360v140z"></path>
    </svg>
  );
};

export default React.memo(SvgIcon);
